// TotalInventoryNearExpiry Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get totalInventoryNearExpiryList from backend then update totalInventoryNearExpiryList in vuex store ***** //
export const updateTotalInventoryNearExpiryList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('outlet_near_expiry_alarm', {
      params: params
    })
    commit('updateTotalInventoryNearExpiryList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch TotalInventoryNearExpiry from backend ***** //
export const fetchTotalInventoryNearExpiryCount = async ({ commit }) => {
  try {
    const result = await Axios.get('outlet_near_expiry_alarm_count')
    commit('fetchTotalInventoryNearExpiryCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Get reportInventoryNearExpiryList from backend then update reportInventoryNearExpiryList in vuex store ***** //
export const updateReportInventoryNearExpiryList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get(`report_near_expiry_alarm/${payload.outlet_id}`, { params: params })
    commit('updateTotalInventoryNearExpiryList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch reportInventoryNearExpiry from backend ***** //
export const fetchReportInventoryNearExpiryCount = async ({ commit }, payload) => {
  try {
    const result = await Axios.get(`report_near_expiry_alarm_count/${payload}`)
    commit('fetchTotalInventoryNearExpiryCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}
